import Entity from "./Entity";

export default class SpiderObstacle extends Entity {

    get collider() {
        return this._collider;
    }

    constructor(anchor, texture) {
        super(anchor, texture);

        this.tweens = new P3.utils.TWEEN.Group();

        this._activated = false;

        this._string = new PIXI.Sprite(P3.assets.texture("web_string"));
        this._string.anchor.set(0.5, 1);
        // this._string.y = -90;
        this._string.height = 400;
        this.addChildAt(this._string, 0);

        this._view.anchor.set(0.5, 0);

        this._collider = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._collider.tint = 0xff0000;
        this._collider.anchor.set(0.5, 0);
        this._collider.width = 60;
        this._collider.height = 80
        this._collider.renderable = false;
        this.addChild(this._collider);

        this.started = false;

        this.headCollision = true;

        this.startDistance = 820;

    }

    start() {
        this.started = true;

        const startY = this._view.y;

        new P3.utils.TWEEN.Tween(this._view, this._tweens)
            .to({y: 480}, 1600)
            .easing(P3.utils.TWEEN.Easing.Elastic.Out)
            .onUpdate(() => {
                this._collider.y = this._view.y;
                this._string.y = this._view.y;
            })
            .start();
    }

    update(dt) {
        this.tweens.update();
    }

    setCollider(x, y, width, height) {
        this._collider.x = x;
        this._collider.y = y;
        this._collider.width = width;
        this._collider.height = height;
    }

    hit() {
        if (!this._activated) {
            this._activated = true;
            this._view.visible = false;
            //this._string.visible = false;
        }
    }

}